// extracted by mini-css-extract-plugin
export default {"leftSidebar":"e8eJaQuak0hYTtg47MJt","leftSidebarMenu":"RxPG8uZulJmopVMujAGa","leftSidebarMenuTop":"RAniyu_fwdFLlhw0H7lg","leftSidebarIcon":"QNpAHy8hwD34BlfQoplv"};